import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StreamCompose from 'global/StreamCompose';
import Text from '@deprecated-ui/common/Text';
import { parseStreamPostContent } from 'utils/stream';
import {
  effects as streamEffects,
  selectors as streamSelectors,
} from 'lib/entities/stream';
import { COMPOSE_MODE } from 'global/StreamCompose/constants';
import { handleErrorPostStream } from 'utils/streamError';
import { Modal } from 'global/StreamWidget/Modals/styled';
import { StreamPostData } from '../../../@types/stream';

interface ModalShareToStockbitProps {
  onCancel?: () => void;
  visible?: boolean;
  post: StreamPostData;
  defaultSharedText?: string;
  [key: string]: any;
}

function ModalShareToStockbit({
  post,
  visible,
  onCancel,
  defaultSharedText,
  ...props
}: ModalShareToStockbitProps) {
  const dispatch = useDispatch();
  const {
    shareStream: { isLoading },
  } = useSelector(streamSelectors);
  const [initialValues, setInitialValues] = useState(null);

  const handleShare = async (val) => {
    const data = {
      ...val,
      postid: post?.postid,
      stockbit: 1,
    };

    const shareHandling = defaultSharedText
      ? streamEffects.postStream
      : streamEffects.shareStream;

    // @ts-ignore
    const share = await dispatch(shareHandling(data));

    // @ts-ignore
    const { error } = share.payload;

    handleErrorPostStream(error);

    if (!error) {
      onCancel();
    }
    return error;
  };

  useEffect(() => {
    if (defaultSharedText) {
      const defaultValue = parseStreamPostContent({
        content_original: defaultSharedText,
      });
      setInitialValues(defaultValue);
    }
  }, [defaultSharedText]);

  const shareMode = defaultSharedText
    ? COMPOSE_MODE.SHARE_TEXT
    : COMPOSE_MODE.REPOST;

  return (
    <Modal
      {...props}
      visible={visible}
      onCancel={onCancel}
      title={
        <Text size="18px" height="44px" family="bold" align="center">
          Share to Stockbit
        </Text>
      }
      footer={null}
      centered
      width={660}
      bodyStyle={{ padding: '0px' }}
    >
      {visible && (
        <StreamCompose
          isLoading={isLoading}
          onSubmit={handleShare}
          onCancel={onCancel}
          mode={shareMode}
          initialValues={defaultSharedText ? initialValues : false}
          post={post}
        />
      )}
    </Modal>
  );
}

export default ModalShareToStockbit;
